'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var PropTypes = require('prop-types');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MIRIcon = function MIRIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'icons/PayuRussia/MIR' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    width: "24px",
    height: "14px",
    viewBox: "0 0 24 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    title: title,
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("defs", {
      children: /*#__PURE__*/jsxRuntime.jsxs("linearGradient", {
        x1: "-0.010383731%",
        y1: "50.0043209%",
        x2: "100.014365%",
        y2: "50.0043209%",
        id: "linearGradient-1",
        children: [/*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#00A0E4",
          offset: "0%"
        }), /*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#0077C3",
          offset: "100%"
        })]
      })
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M15.987,7.0523575 L15.987,9.8468575 L17.5395,9.8468575 L17.5395,8.1908575 L19.299,8.1908575 C20.0385,8.1848575 20.66775,7.7123575 20.9055,7.0523575 L15.987,7.0523575 Z",
      fill: "#37A72E"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M15.78075,4.7503075 C15.87,5.8925575 16.95075,6.7933075 18.27075,6.7933075 L18.27075,6.7933075 L20.97,6.7933075 C20.9895,6.6890575 20.99925,6.5810575 20.99925,6.4700575 L20.99925,6.4700575 C20.99925,5.5243075 20.2365,4.7570575 19.29225,4.7503075 L19.29225,4.7503075 L15.78075,4.7503075 Z",
      fill: "url(#linearGradient-1)"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M13.484325,6.7644325 C13.500075,6.7351825 13.530075,6.7164325 13.565325,6.7164325 C13.616325,6.7164325 13.656825,6.7561825 13.658325,6.8064325 L13.658325,9.8206825 L15.211575,9.8206825 L15.211575,4.7499325 L13.658325,4.7499325 C13.461825,4.7566825 13.239825,4.9006825 13.156575,5.0784325 L11.921325,7.7274325 C11.918325,7.7379325 11.913825,7.7484325 11.907075,7.7574325 C11.888325,7.7851825 11.856825,7.8024325 11.821575,7.8024325 C11.764575,7.8024325 11.718075,7.7566825 11.718075,7.6996825 L11.718075,4.7499325 L10.166325,4.7499325 L10.166325,9.8206825 L11.718075,9.8206825 C11.913075,9.8101825 12.129825,9.6676825 12.212325,9.4921825 L13.479825,6.7734325 C13.480575,6.7711825 13.481325,6.7689325 13.482825,6.7666825 L13.484325,6.7644325 Z",
      fill: "#37A72E"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M6.7797,9.8209075 L5.66295,9.8209075 L4.75545,6.8516575 C4.74645,6.8044075 4.70445,6.7676575 4.6542,6.7676575 C4.59795,6.7676575 4.5522,6.8134075 4.5522,6.8696575 L4.5522,9.8209075 L2.9997,9.8209075 L2.9997,4.7501575 L4.33245,4.7501575 L4.7292,4.7501575 C5.0142,4.7501575 5.3142,4.9714075 5.39745,5.2444075 L6.1527,7.7156575 C6.19095,7.8386575 6.2517,7.8379075 6.2892,7.7156575 L7.0452,5.2444075 C7.12845,4.9714075 7.42695,4.7501575 7.7127,4.7501575 L8.10945,4.7501575 L9.4422,4.7501575 L9.4422,9.8209075 L7.8897,9.8209075 L7.8897,6.8711575 C7.8897,6.8134075 7.84395,6.7676575 7.7877,6.7676575 C7.7367,6.7676575 7.6947,6.8051575 7.68645,6.8531575 L6.7797,9.8209075 Z",
      fill: "#37A72E"
    })]
  }));
};
MIRIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MIRIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'icons/PayuRussia/MIR'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var MIRIcon$1 = MIRIcon;
MIRIcon.propTypes = {
  title: PropTypes__default.default.string
};

exports.default = MIRIcon$1;
//# sourceMappingURL=MIRIcon.js.map
